

import { Color } from 'lib/styles';
import * as React from 'react';
import styled from 'styled-components';
import { Main, Text } from 'styles/themeColors';
import { Height } from 'styles/themeHeights';
import { Space } from 'styles/themeSpaces';

const LabelSubText = styled.label<{ italicSubText: boolean }>`
    color: ${Color.darkGray};
    margin-left: 5px;
    ${({ italicSubText }) => italicSubText && `
        font-style: italic;
    `}
`;

const Label = styled.label<any>`
  font-size: ${Space.sp2x};
  line-height: ${Height.xsPlus};
`;

const Container = styled.div<{ hasError: boolean }>`
  color: ${({ hasError }) => (hasError ? Color.error : 'inherit')};
  margin-bottom: ${Space.spBase};
`;


interface Props {
    hasError?: boolean;
    disabled?: boolean;
    text: string;
    subText?: string;
    italicSubText?: boolean;
}

const InputLabel: React.FC<Props> = (props: Props) => {

    const { text, subText, hasError, italicSubText = false } = props;

    return (
        <Container hasError={!!hasError}>
            <Label>{text}</Label>
            {subText && <LabelSubText italicSubText={italicSubText}>{subText}</LabelSubText>}
        </Container>
    );
}

export default React.memo(InputLabel);